import { useQuery } from "@tanstack/react-query";
import { Navigate, useParams } from "react-router";
import { prefetchOrganisationHierarchy, useGetOrganisationHierarchy } from "../../../api/organisations";
import { prefetch } from "../../../api/prefetch";
import { scimAdGroupsQueryOptions } from "../../../api/scimAdGroups";
import { scimPermissionsQueryOptions } from "../../../api/scimPermissions";
import { PageSpinner } from "../../../shared/Page";
import { OrganisationTree } from "../shared/OrganisationTree";
import { SettingsPageLayout } from "../shared/SettingsPageLayout";
import { ScimMappingFields } from "./ScimMappingFields";

export const prefetchScimMappingPage = () => {
  prefetchOrganisationHierarchy();
  prefetch(scimPermissionsQueryOptions());
  prefetch(scimAdGroupsQueryOptions());
};

export const ScimMapping = () => {
  const organisationHierarchyQuery = useGetOrganisationHierarchy();
  const adGroupsQuery = useQuery(scimAdGroupsQueryOptions());
  const permissionsQuery = useQuery(scimPermissionsQueryOptions());
  const params = useParams();

  if (!organisationHierarchyQuery.data || !adGroupsQuery.data || !permissionsQuery.data) return <PageSpinner />;
  if (!params.tenantId) return <Navigate to={organisationHierarchyQuery.data.id} replace />;

  return (
    <SettingsPageLayout
      sidebarContent={<OrganisationTree organisationHierarchy={organisationHierarchyQuery.data} />}
      mainContent={
        <ScimMappingFields
          organisationHierarchy={organisationHierarchyQuery.data}
          adGroups={adGroupsQuery.data}
          permissions={permissionsQuery.data}
        />
      }
    />
  );
};
